import { Form } from "@circle-react-uikit/Form";

import {
  buildNotificationOptions,
  type PostNotificationSpaceType,
} from "../../utils/notificationOptions";

interface PostNotificationFieldProps {
  postType: PostNotificationSpaceType;
}

export const PostNotificationField = ({
  postType,
}: PostNotificationFieldProps) => (
  <Form.Item
    name="notification_type"
    hideLabel
    hideDescription
    hideBorder
    fullWidth
    isFirstChild
  >
    <Form.CheckboxGroup
      name="notification_type"
      options={buildNotificationOptions(postType)}
    />
  </Form.Item>
);
